import apiClient from './client';

export interface RepairForm {
  id: string;
  device: string | any;
  serialNumber: string;
  assetTag?: string;
  serviceProvider: string | any;
  serviceProviderName: string;
  faultDescription: string;
  accessories?: string;
  deviceCondition?: string;
  estimatedCost?: number;
  estimatedCompletionDate?: string;
  deliveryDate: string;
  deliveredBy: string;
  deliveredBySignature?: string;
  receivedBy?: string;
  receivedBySignature?: string;
  notes?: string;
  branch: string | any;
  createdBy: string | any;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateRepairFormDto {
  device: string;
  serialNumber: string;
  assetTag?: string;
  serviceProvider: string;
  serviceProviderName: string;
  faultDescription: string;
  accessories?: string;
  deviceCondition?: string;
  estimatedCost?: number;
  estimatedCompletionDate?: string;
  deliveryDate: string;
  deliveredBy: string;
  deliveredBySignature?: string;
  receivedBy?: string;
  receivedBySignature?: string;
  notes?: string;
}

export const repairFormsApi = {
  getAll: async (): Promise<RepairForm[]> => {
    const response = await apiClient.get('/repair-forms');
    return response.data.map((item: any) => ({ ...item, id: item._id }));
  },

  getOne: async (id: string): Promise<RepairForm> => {
    const response = await apiClient.get(`/repair-forms/${id}`);
    return { ...response.data, id: response.data._id };
  },

  getByDevice: async (deviceId: string): Promise<RepairForm[]> => {
    const response = await apiClient.get(`/repair-forms/device/${deviceId}`);
    return response.data.map((item: any) => ({ ...item, id: item._id }));
  },

  create: async (data: CreateRepairFormDto): Promise<RepairForm> => {
    const response = await apiClient.post('/repair-forms', data);
    return { ...response.data, id: response.data._id };
  },

  update: async (id: string, data: Partial<CreateRepairFormDto>): Promise<RepairForm> => {
    const response = await apiClient.put(`/repair-forms/${id}`, data);
    return { ...response.data, id: response.data._id };
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/repair-forms/${id}`);
  },
};
